package ru.villawonka.app.presentation.screens.setup.compose.layout

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.surfaceMiddle
import ru.villawonka.app.presentation.screens.setup.compose.SetupCallbacks
import ru.villawonka.app.presentation.screens.setup.viewmodel.SetupUIState

@Composable
fun SetupStepStateLayout(
    state: SetupUIState.Step,
    callbacks: SetupCallbacks
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = if (state is SetupUIState.Step.Congrats) Arrangement.Center else Arrangement.Top,
        modifier = Modifier
            .background(MaterialTheme.colors.surfaceMiddle)
            .fillMaxSize()
            .padding(horizontal = 16.dp)
            .verticalScroll(rememberScrollState())
    ) {
        AppSpacer(16.dp)
        when (state) {
            is SetupUIState.Step.Language -> SetupLanguageStepLayout(state, callbacks)
            is SetupUIState.Step.Country -> SetupCountryStepLayout(state, callbacks)
            is SetupUIState.Step.Currency -> SetupCurrencyStepLayout(state, callbacks)
            is SetupUIState.Step.Congrats -> SetupCongratsStepLayout(callbacks)
        }
        AppSpacer(16.dp)
    }
}